// uuid
const uuid = 'user_uuid_8301'
export const getUuid = () => localStorage.getItem(uuid);
export const setUuid = (val: string) => localStorage.setItem(uuid, val);
